import { createContext, useContext, FC , useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "./useLocalStorage";
import axios from "axios";
import api from "../data/apiconfig";
 

export interface IAuth {
    user: string;
    token: string;
    login: (user:string, token:string) => Promise<void>;
    logout: () => void;
}

declare let promiseFunc: (user:string, token:string) => Promise<void>;

const AuthContext = createContext<IAuth>({user:"" ,
                                          token:"",
                                          login: (username:string, token:string) => promiseFunc("",""),
                                          logout: () => {}});


export const AuthProvider = ({children}:any) => {
  const [user, setUser] = useLocalStorage("user", null);
  const [token, setToken] = useLocalStorage("token", null);
  const navigate = useNavigate();

  // call this function when you want to authenticate the user
  const login = async (username:string,token:string) => {
    setToken(token);
    setUser(username);
    navigate("/");
    
  };

  // call this function to sign out logged in user
  const logout = () => {
    setUser(null);
    setToken(null);
    navigate("/", { replace: true });

  };

  const value = useMemo(
    () => ({
      user,
      token,
      login,
      logout,
    }),
    [user, token]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};